import React from "react";
import { Helmet } from "react-helmet";

const AboutUs = () => {
  return (
    <div className="page-container">
      <Helmet>
        <title>About Us | AAMSchool</title>
        <link rel="canonical" href="https://www.aamschool.in/about-us" />
        <meta
          name="description"
          content="Learn about AAMSchool, our purpose, our content approach, and how we help students and job seekers track education and recruitment updates."
        />
        <meta property="og:title" content="About Us | AAMSchool" />
        <meta
          property="og:description"
          content="Learn about AAMSchool, our purpose, our content approach, and how we help students and job seekers track education and recruitment updates."
        />
        <meta property="og:url" content="https://www.aamschool.in/about-us" />
        <meta property="og:type" content="website" />
      </Helmet>
      <h1>About Us</h1>
      <p className="page-lead">
        AAMSchool Naukari is an informational and educational platform created to help students,
        job seekers, and exam aspirants follow important updates in a simpler format.
      </p>
      <section className="page-policy-section">
        <h2>Who We Are</h2>
        <p>
          Welcome to AAMSchool Naukari, your destination for government job updates, admit cards,
          results, answer keys, quiz practice, and exam-related learning support across India.
        </p>
        <p>
          Our mission is to present important information in a simpler and more organized format so
          students and aspirants can understand key updates faster and continue to the official
          source for confirmation.
        </p>
      </section>

      <section className="page-policy-section">
        <h2>What We Provide</h2>
        <ul>
          <li>Latest government job notifications and application alerts</li>
          <li>Admit card, result, and answer key updates</li>
          <li>Exam syllabus pages and topic-wise study support</li>
          <li>Practice quizzes and revision-oriented learning sections</li>
          <li>Important dates, useful links, and general exam awareness content</li>
        </ul>
      </section>

      <section className="page-policy-section">
        <h2>How We Try To Help Users</h2>
        <p>
          Many users visit education and job websites when they need information quickly. Our goal
          is to reduce confusion by organizing updates into readable pages that are easier to scan
          than raw notices alone.
        </p>
        <p>
          Along with update pages, we are also building study-support sections such as syllabus
          pages and quizzes so learners can move from information discovery to active preparation.
        </p>
      </section>

      <section className="page-policy-section">
        <h2>Editorial Approach</h2>
        <p>
          We try to collect and organize information from official recruitment boards, institutions,
          examination authorities, and other trusted public sources. Even with careful effort, users
          should always verify eligibility, dates, fees, and instructions from the official website
          before acting on any notice.
        </p>
        <p>
          AAMSchool Naukari is an independent platform and is not associated with any government
          organization. Our content is published for educational and informational purposes only.
        </p>
      </section>
    </div>
  );
};

export default AboutUs;
